// === BTurkish — Cart Shipping Motivation Engine ===
// 4-tier system: SAR + AED only
// Simple blocked/allowed: all other currencies

// --- Tiered currencies (SAR + AED) ---
const CURRENCY_TIERS = {
  SAR: { min: 85, tier1Max: 139, free: 399 },
  AED: { min: 85, tier1Max: 139, free: 399 },
};

// --- Simple currencies (all others) ---
const SIMPLE_CURRENCIES = {
  QAR: 140,
  GBP: 50,
  EUR: 45,
};

const USD_COUNTRY_MINS = {
  KW: 40,
  BH: 35,
  JO: 40,
  OM: 40,
  US: 60,
};

const DEFAULT_USD_MIN = 50;

function isTieredCurrency(currency) {
  return CURRENCY_TIERS[currency] !== undefined;
}

function getTiers(currency) {
  return CURRENCY_TIERS[currency];
}

function getSimpleMinimum(currency, country) {
  if (SIMPLE_CURRENCIES[currency] !== undefined) return SIMPLE_CURRENCIES[currency];
  if (currency === 'USD') {
    return USD_COUNTRY_MINS[country] !== undefined ? USD_COUNTRY_MINS[country] : DEFAULT_USD_MIN;
  }
  const rate = parseFloat(Shopify.currency.rate) || 1;
  return Math.round(DEFAULT_USD_MIN * rate);
}

function getTier(cartTotal, tiers) {
  if (cartTotal < tiers.min)      return 'BLOCKED';
  if (cartTotal < tiers.tier1Max) return 'TIER1';
  if (cartTotal < tiers.free)     return 'TIER2';
  return 'TIER3';
}

function formatAmount(amount) {
  return String(Math.round(amount));
}

function isArabic() {
  return document.documentElement.lang === 'ar' ||
         !!document.querySelector('html[lang="ar"]');
}

function getCurrencyDisplay(currency, ar) {
  if (!ar) return currency;
  const symbols = { SAR: 'ر.س', AED: 'د.إ', QAR: 'ر.ق' };
  return symbols[currency] || currency;
}

function getContinueShoppingLink(ar) {
  const label = ar ? 'تابع التسوق ←' : 'Continue Shopping →';
  let lastCollection = sessionStorage.getItem('lastCollectionUrl') || '/collections';

  const currentLocaleMatch = window.location.pathname.match(/^\/([a-z]{2})(\/|$)/);
  const currentLocale = currentLocaleMatch ? currentLocaleMatch[1] : null;

  if (currentLocale) {
    try {
      const url = new URL(lastCollection, window.location.origin);
      const storedLocaleMatch = url.pathname.match(/^\/([a-z]{2})(\/|$)/);
      const storedLocale = storedLocaleMatch ? storedLocaleMatch[1] : null;
      if (storedLocale !== currentLocale) {
        const cleanPath = storedLocale
          ? url.pathname.replace(/^\/[a-z]{2}/, '')
          : url.pathname;
        url.pathname = '/' + currentLocale + cleanPath;
        lastCollection = url.href;
      }
    } catch (e) {}
  }

  return `<a href="${lastCollection}" class="min-order-continue">${label}</a>`;
}

function buildTieredHTML(tierClass, fillPct, messageEN, messageAR, showLink) {
  const ar   = isArabic();
  const msg  = ar ? messageAR : messageEN;
  const link = showLink
    ? `<div class="min-order-link">${getContinueShoppingLink(ar)}</div>`
    : '';
  return (
    `<div class="min-order-progress-wrap ${tierClass}">` +
      `<div class="min-order-bar-track">` +
        `<div class="min-order-bar-fill" style="width:${fillPct}%"></div>` +
      `</div>` +
      `<p class="min-order-message">${msg}</p>` +
      link +
    `</div>`
  );
}

function buildSimpleHTML(fillPct, messageEN, messageAR) {
  const ar  = isArabic();
  const msg = ar ? messageAR : messageEN;
  return (
    `<div class="min-order-progress-wrap tier-blocked">` +
      `<div class="min-order-bar-track">` +
        `<div class="min-order-bar-fill" style="width:${fillPct}%"></div>` +
      `</div>` +
      `<p class="min-order-message">${msg}</p>` +
    `</div>`
  );
}

function showCheckout() {
  document.querySelectorAll('.hidden-when-limit').forEach(el => {
    el.style.display = 'block';
    el.classList.remove('checkout-disabled');
  });
}

function hideCheckout() {
  document.querySelectorAll('.hidden-when-limit').forEach(el => {
    el.style.display = 'none';
    el.classList.add('checkout-disabled');
  });
}

function setMotivationBar(html) {
  document.querySelectorAll('.shown-when-limit').forEach(el => {
    el.style.display = 'block';
    el.innerHTML = html;
  });
}

function hideMotivationBar() {
  document.querySelectorAll('.shown-when-limit').forEach(el => {
    el.style.display = 'none';
    el.innerHTML = '';
  });
}

function cartUpdated() {
  fetch('/cart.js')
    .then(r => {
      if (!r.ok) throw new Error('Network response was not ok');
      return r.json();
    })
    .then(data => {
      const cartTotal   = data.total_price / 100;
      const currency    = Shopify.currency.active;
      const country     = window.shopCountryCode || '';
      const ar          = isArabic();
      const currDisplay = getCurrencyDisplay(currency, ar);

      if (isTieredCurrency(currency)) {
        const tiers = getTiers(currency);
        const tier  = getTier(cartTotal, tiers);

        let fillPct, tierClass, messageEN, messageAR, showLink;

        if (tier === 'BLOCKED') {
          const rem = formatAmount(tiers.min - cartTotal);
          fillPct    = Math.min(100, Math.round((cartTotal / tiers.min) * 100));
          tierClass  = 'tier-blocked';
          showLink   = true;
          messageEN  = `🛒 Add <strong>${rem} ${currency}</strong> more to reach the minimum order amount`;
          messageAR  = `🛒 أضف منتجات بقيمة <strong>${rem} ${currDisplay}</strong> للوصول للحد الأدنى للطلب`;
          hideCheckout();

        } else if (tier === 'TIER1') {
          const rem = formatAmount(tiers.tier1Max - cartTotal);
          fillPct    = Math.min(100, Math.round((cartTotal / tiers.tier1Max) * 100));
          tierClass  = 'tier-1';
          showLink   = true;
          messageEN  = `🚀 Don't miss ~50% off shipping — add <strong>${rem} ${currency}</strong> more to your order`;
          messageAR  = `🚀 لاتفوت خصم ٥٠٪ على الشحن بإضافة منتجات بقيمة <strong>${rem} ${currDisplay}</strong> لطلبك`;
          showCheckout();

        } else if (tier === 'TIER2') {
          const rem = formatAmount(tiers.free - cartTotal);
          fillPct    = Math.min(100, Math.round((cartTotal / tiers.free) * 100));
          tierClass  = 'tier-2';
          showLink   = true;
          messageEN  = `🎁 You're only <strong>${rem} ${currency}</strong> away from FREE shipping!`;
          messageAR  = `🎁 باقيلك <strong>${rem} ${currDisplay}</strong> وتوصل للشحن المجاني! أضف منتجات`;
          showCheckout();

        } else {
          fillPct    = 100;
          tierClass  = 'tier-3';
          showLink   = false;
          messageEN  = `✅ Congrats! You've got Free Shipping — you'll see it at the next step.`;
          messageAR  = `✅ مبروك! شحن طلبك مجاني علينا.`;
          showCheckout();
        }

        const displayPct = tier === 'TIER3' ? 100 : Math.min(99, fillPct + 10);
        const html = buildTieredHTML(tierClass, displayPct, messageEN, messageAR, showLink);
        setMotivationBar(html);

      } else {
        const minimum = getSimpleMinimum(currency, country);

        if (cartTotal < minimum) {
          const rem     = formatAmount(minimum - cartTotal);
          const fillPct = Math.min(100, Math.round((cartTotal / minimum) * 100));
          const messageEN = `🛒 Add <strong>${rem} ${currency}</strong> more to reach the minimum order amount`;
          const messageAR = `🛒 أضف منتجات بقيمة <strong>${rem} ${currDisplay}</strong> للوصول للحد الأدنى للطلب`;
          setMotivationBar(buildSimpleHTML(fillPct, messageEN, messageAR));
          hideCheckout();
        } else {
          hideMotivationBar();
          showCheckout();
        }
      }
    })
    .catch(err => {
      console.error('Error fetching cart data:', err);
    });
}

window.cartUpdated = cartUpdated;

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('input[name="agree_checkbox"]').forEach(cb => {
    cb.checked = true;
    cb.dispatchEvent(new Event('change', { bubbles: true }));
  });
  cartUpdated();
});

document.addEventListener('cart:change', () => {
  cartUpdated();
});
